export { default } from './ZoomGatedEmbed';
